import React from 'react';

const Title = (props) => {
  const className = "input bn foutline-0 pa0 f2 fw3 w-50 dark-gray"

  if (typeof props.children === 'string') {
    return (
      <div className={className}>
        {props.children}
      </div>
    )
  } else {
    return React.cloneElement(props.children, {
      ...props.children.props,
      className
    })
}
}

export default Title;


/** WEBPACK FOOTER **
 ** ./src/components/Title.js
 **/